import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { LuClock } from 'react-icons/lu'
import { FaHeart } from 'react-icons/fa'
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5'
import Button from '../../atoms/Button'

const ActionButton = ({ hotPick, onSendLike }) => {
  const navigate = useNavigate()
  const theme = useTheme()

  const renderIcon = useCallback(() => {
    if (hotPick.user_match) {
      if (hotPick.user_match.chat_id) {
        return <IoChatbubbleEllipsesOutline size={24} />
      }
      return <LuClock size={24} color={theme.palette.grayscale[2]} />
    }
    return <FaHeart size={20} color={theme.palette.error[0]} className="blink" />
  }, [hotPick, theme.palette])

  return (
    <Button
      padding={0}
      disabled={hotPick.user_match && !hotPick.user_match.chat_id}
      onClick={() => {
        if (hotPick.user_match?.chat_id) {
          navigate(`/chat/${hotPick.user_match.chat_id}`)
        } else {
          return onSendLike(hotPick.hot_pick_id)
        }
      }}
      style={{
        width: '2.5rem',
        height: '2.5rem',
        borderRadius: '50%',
        position: 'absolute',
        bottom: '0.4rem',
        right: '0.4rem',
      }}
    >
      {renderIcon()}
    </Button>
  )
}

ActionButton.propTypes = {
  hotPick: PropTypes.shape({
    hot_pick_id: PropTypes.string,
    user_match: PropTypes.shape({
      chat_id: PropTypes.string,
    }),
  }),
  onSendLike: PropTypes.func,
}

ActionButton.defaultProps = {
  hotPick: {},
  onSendLike: () => {},
}

export default ActionButton
